import LeadForm from './LeadForm'
import type { FinalCtaLabels, LeadFormLabels } from '@/pages/landing/types'

export default function FinalCta({ labels, leadForm, kegCountHint, source }: {
  labels: FinalCtaLabels
  leadForm: LeadFormLabels
  // Mirrors the calculator's fleet slider: the visitor states their fleet size once.
  kegCountHint?: number
  source: string
}) {
  return (
    <section id="waitlist" className="py-[76px] px-[22px]">
      <div className="max-w-[760px] mx-auto relative overflow-hidden bg-ink border-2 border-ink rounded-[28px] p-14 text-center shadow-[10px_10px_0_#E2461F]">
        <img
          src="/kego.png"
          alt=""
          aria-hidden="true"
          className="absolute -right-5 -bottom-6 w-44 opacity-10 pointer-events-none select-none"
        />
        <h2 className="font-body font-extrabold text-paper text-3xl md:text-4xl tracking-tight relative">
          {labels.title_pre}<br /><span className="font-script font-normal text-mustard">{labels.title_script}</span>
        </h2>
        <p className="text-paper/70 mt-4 mb-6 max-w-[40ch] mx-auto relative">{labels.body}</p>
        {/* The full LeadForm variant is styled for a light card (text-ink labels, bg-paper
            inputs). It needs its own light panel inside this dark block, otherwise the
            labels and the disclaimer render dark-on-dark. */}
        <div className="relative mx-auto max-w-[420px] rounded-[18px] border-2 border-ink bg-card p-6 text-left">
          <LeadForm labels={leadForm} kegCountHint={kegCountHint} source={source} />
        </div>
      </div>
    </section>
  )
}
